<template>
	<div class="col pl-0 location-chooser-root expand-error input-no-error" @mouseup="clearFormValidation()">
		<el-form :model="form" :rules="rules" ref="mainForm" class="pb-2">
			<el-form-item
				:prop="'locationsData.' + index + ''"
				:rules="{validator: validator, trigger: 'validate'}"
				class="w-100 error-padding__10"
				v-for="(altLocation, index) in form.locationsData" :key="index">
				<div class="row align-items-center mx-0 mt-2 qwoach-form">
					<!--									<div class="col p-0">-->
					<!--										<div class="row px-0 mx-0">-->
<!--					<qw-select-->
<!--						class="mb-1"-->
<!--						style="width: 170px;"-->
<!--						v-model="altLocation.type"-->
<!--						filterable-->
<!--						allow-create-->
<!--						default-first-option-->
<!--						no-match-text="Press enter for custom name"-->

<!--						:options="altLocationOptions"-->
<!--					/>-->
					<el-select
						class="pointer mx-0 p-0 input-border-bottom height__15em"
                        style="width: 170px;"
						v-model="altLocation.type"
						filterable
						allow-create
						default-first-option
						no-match-text="Press enter for custom name"
						@change="onLocationTypeChanged(altLocation)"
						:placeholder="altLocationWherePlaceholder(index)">
						<el-option
							v-for="(item, index) in altLocationOptions"
							:key="index"
							:label="item"
							:value="item"
							:disabled="index === altLocationOptions.length - 1">
						</el-option>
					</el-select>

					<qw-input class="pointer mx-2 col input-border-bottom height__15em"
							  v-show="!altLocation.askInvitee"
							  :placeholder="altLocationDetailsPlaceholder(index)"
							  v-if="altLocation.type !== 'Let invitee suggest' && !altLocation._isIntegrationAvailable"
							  v-model="altLocation.coachContact">
					</qw-input>
					<div v-else-if="altLocation._isIntegrationAvailable" class="ml-4">
						<div v-if="altLocation.isIntegrated()">
							Connected <ToolTipView :text="altLocation._connectedText"/>

						</div>
						<qw-button v-else @click="startIntegrationClicked(altLocation)">{{altLocation._connectButtonTitle || "Connect"}}</qw-button>
					</div>
					<i class="fontello icon-trash button-circle"
					   :class="{'button-hidden': index === 0}"
					   @click="index > 0 ? deleteAlternativeLocation(index) : null"></i>

					<div class="layout-spacer"></div>

					<el-checkbox
						v-if="altLocation.type !== 'Let invitee suggest' && !altLocation._isIntegrationAvailable"
						v-model="altLocation.askInvitee" class="mr-0"
					@change="onAskInviteeChanged(altLocation.askInvitee)">
						I will contact my invitee
					</el-checkbox>
					<ToolTipView
						v-if="altLocation.type !== 'Let invitee suggest' && !altLocation._isIntegrationAvailable"
						position="bottom"
						:analyticsProps="{label: 'Ask invitee', ...analyticsPropsMethod()}"
						:disabled="index > 1" class="item" :enterable=false
						effect="dark" placement="right">
						<template #icon>
							<div :style="{opacity: index < 2 ? 1 : 0}" class="infolink"></div>
						</template>
						<div style="max-width: 240px;">
							If switched on, your invitee will be asked to provide their details
							so you can contact them first.
							<br/><br/>
							If switched off, the contact details you provide will be shared with your client upon session confirmation.

<!--							You can still optionally provide your contact details so your invitee can-->
<!--							contact you as well.-->
						</div>
					</ToolTipView>


					<!--										</div>-->
				</div>
			</el-form-item>
		</el-form>

		<div class="row mx-0" style="line-height: 15px">
			<span class="text-primary clickable small pb-2"
			   @click="addAlternativeLocation">+ Add one more location</span>
			<ToolTipView class="item"
						 :analyticsProps="{label: 'Add location', ...analyticsPropsMethod()}"
						placement="right">
				<template #icon>
					<div class="infolink"></div>
				</template>
				<div style="max-width: 240px;">
					You can suggest multiple locations for your invitees to choose from.
					<br/><br/>
					Like phone call, Skype, WhatsApp etc or their custom way to connect.

				</div>
			</ToolTipView>
		</div>


	</div>

</template>

<script>
    import {LocationItem} from "@/core/js/model/scheduler/LocationItem";
    import QwInput from "@/core/components/Controls/QwInput.vue";
    import {deleteConfirmDialog} from "@/core/components/Dialogs/dialog";

	import BaseComponent from "@/core/components/BaseComponent.vue";
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
	import {LocationTypeId} from "@shared/scheduler/LocationTypeId";
	import UrlResponseReader from "@/core/js/backend/UrlResponseReader";

	export default {
		extends: BaseComponent,
        name: "LocationChooser",
        components: {ToolTipView, QwInput},
        props: {
            locations: {type: Array, default: () => []},
            formName: String,
        },

        watch: {
            locations: {
                immediate: true,
                handler(newVal, oldVal) {
                    console.log("locations: newVal = ", newVal)
                    this.form.locationsData = newVal || [];
                    if (this.form.locationsData.length === 0) {
                        this.addAlternativeLocation()
                    }
                    this.setupLocationItems()
                }
            }
        },

        data() {
            return {
				urlResponseReader: null,
                formNames: ["mainForm"],
                form: {
                    locationsData: [],
                },
                rules: {},
				availableIntegrations: [
					{
						name: "Zoom meeting",
						profileIntegrationStatusKey: "zoomIntegration",
						connectButtonTitle: "Connect my Zoom",
						connectedText: "Zoom is connected and a unique zoom meeting link will be sent to each participant as they schedule sessions with you."
					},
					{
						name: "Google Meet",
						profileIntegrationStatusKey: "gmailIntegration",
						connectButtonTitle: "Connect Google Meet",
						connectedText: "Google meet is connected and a unique meeting link will be sent to each participant as they schedule sessions with you."
					},
				],
                altLocationOptions: ["Zoom meeting", "Google Meet", "Phone call", "WhatsApp", "Skype",  "In person", "Microsoft Teams", "Let invitee suggest", "Or type anything and press 'Enter'"],
                altLocationSuggestion: ["Zoom meeting url", "Google Meet url", "phone number", "WhatsApp number", "skype id", "address", "link to connect", "", "Or type anything and press 'Enter'"],

            }
        },
		created() {
			this.urlResponseReader = new UrlResponseReader(this)
			// this.loadIntegrations()
		},

		mounted() {
			this.urlResponseReader.processUrlResponse()
		},

        methods: {

			setupLocationItems(){
				let locationsData = this.form.locationsData
				console.log("setupLocationItems: locationsData = ", JSON.parse(JSON.stringify(locationsData)))

				for(let locationItem of locationsData){
					locationItem.setupIfNeeded()
					let integrationData = this.getIntegrationData(locationItem)
					let integrationStatus = integrationData ? this.userProfile.integrationsList[integrationData.profileIntegrationStatusKey] : "NOT_SET"
					locationItem._isIntegrationAvailable = !!integrationData
					locationItem._integrationStatus = integrationStatus;
					if(integrationData){
						locationItem._connectButtonTitle = integrationData.connectButtonTitle;
						locationItem._connectedText = integrationData.connectedText
						locationItem.coachContact = null
						locationItem.clientContact = null
						locationItem.askInvitee = false
					}
				}
			},

            getLocations(){
                console.log("getLocations: ", this.form.locationsData)
			    return this.form.locationsData
			},
            async validate() {
                return this.validateForm("mainForm")
            },

			onAskInviteeChanged(value){
            	this.$analyticManager.trackEvent("'Ask invitee' checkbox changed", {value: value, ...this.analyticsPropsMethod()})
			},

            addAlternativeLocation() {
            	this.$analyticManager.trackEvent("Add location clicked", this.analyticsPropsMethod())
                this.form.locationsData.push(new LocationItem())
            },

			onFormFailed(formNameArray, params, error) {
				return false
			},

            async deleteAlternativeLocation(index) {
				let _ = this.$analyticManager.trackEvent("Delete location clicked", this.analyticsPropsMethod())
                let res = await deleteConfirmDialog({
					itemName: "location"
                })
                if(res){
                    this.form.locationsData.splice(index, 1)
                }
            },
            altLocationWherePlaceholder(index) {
                let location = this.form.locationsData[index]
                // let suggestion = this.altLocationSuggestions[index % this.altLocationSuggestions.length]
                // return `Type (ex. "${suggestion.type}")`

                return `Location type` + (location.askInvitee ? "*" : "")

            },
            altLocationDetailsPlaceholder(index) {
                let location = this.form.locationsData[index]
                // let suggestion = this.altLocationSuggestions[index % this.altLocationSuggestions.length]
                // return `ex. ${suggestion.details}`
                let locationType = location.type
                let locationTypeIndex = this.altLocationOptions.indexOf(locationType)
                let suggestion = "contact details"
                if (locationTypeIndex >= 0) {
                    suggestion = "your " + this.altLocationSuggestion[locationTypeIndex]
                }
                return suggestion + (location.askInvitee ? " (optional)" : "*")
            },

            validator(rule, locationItem, callback, source, options) {
                console.log("LocationChooser: locationItem = ", locationItem, ", source = ", source)

                let errorMsg;
                if (locationItem.askInvitee && !locationItem.type) {
                    errorMsg = "Please provide location type so we can request the details from your invitee"
                }
                if (!locationItem._isIntegrationAvailable && !locationItem.askInvitee && !locationItem.coachContact && (locationItem.type || "").indexOf("invitee") < 0) {
                    errorMsg = "Please provide details for your client to connect"
                }
                if(locationItem._isIntegrationAvailable && !locationItem.isIntegrated()){
					errorMsg = `Please connect your account for ${locationItem.type}`
				}
                callback(errorMsg);
            },

            onLocationTypeChanged(locationItem) {
                console.log("onLocationTypeChanged: locationItem = ", locationItem)
                let locationTypeIndex = this.altLocationOptions.indexOf(locationItem.type)
                if (locationTypeIndex >= 0) {
                    locationItem.typeSuggestion = this.altLocationSuggestion[locationTypeIndex];
					locationItem.typeId = null
					locationItem.isIntegrationAvailable = false
                }
                this.setupLocationItems()
                // locationItem.coachContact = ""
                this.$forceUpdate();
                this.$analyticManager.trackEvent("Location type changed", {value: locationItem.type, ...this.analyticsPropsMethod()})
            },

			getIntegrationData(locationItem){
				for(let integrationName of this.availableIntegrations){
					if(integrationName.name === locationItem.type){
						return integrationName
					}
				}
				return null
			},

			async startIntegrationClicked(locationItem){
				this.progressBlocking()
				try{
            		await this.emitPromise("startIntegrationClicked")
					this.progressBlocking()
					let originUrl = window.location.href
					let redirectUrl
					switch (locationItem.typeId){
						case LocationTypeId.ZOOM:
							redirectUrl = await this.$dataManager.apiGetZoomAuthUrl({originUrl})
							break
						case LocationTypeId.GOOGLE_MEET:
							redirectUrl = await this.$dataManager.apiPostGCalendarAuthStart({destination: originUrl})
							break
					}
					if(redirectUrl){
						return window.location.href = redirectUrl
					}
					this.hideProgress()
				} catch (error){
            		this.handleError(error)
				}
			}

        }
    }
</script>

<style lang="scss">

.location-chooser-root{

	//.el-form-item__content{
	//	line-height: inherit;
	//}

    .error-padding__10 .el-form-item__error {
        //padding-left: 20px
    }


}

</style>
